import { IconComponentProps } from '../IconTypes';

const CaretDown = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.71 11.71L11.3 14.3C11.69 14.69 12.32 14.69 12.71 14.3L15.3 11.71C15.93 11.08 15.48 10 14.59 10H9.41C8.52 10 8.08 11.08 8.71 11.71Z"
      fill="currentColor"
    />
  </svg>
);

export default CaretDown;
